// extracted by mini-css-extract-plugin
export default {"container":"Empty_container__2Mg4p","text":"Empty_text__TBYlI","emptyBoxTitle":"Empty_emptyBoxTitle__nlBBi","emptyBoxSubtitle":"Empty_emptyBoxSubtitle__up+PV"};